<template>
	<div class="dental-carving-machine-list">
		<div class="dental-carving-machine-con">
			<div class="title">
				<i class="x-icon-keys"></i><span class="x-tit-con">5-axis Dental Carving Machine</span>
			</div>

			<div class="list">
				<img :src="solution_image_01" alt="Xhorse"/>

				<ul>


					<li>
						<div class="dot">·</div>
						<div class="ll">Support 5-axis linkage RTCP tool tip control technology;</div>
					</li>
					<li>
						<div class="dot">·</div>
						<div class="ll">Multi-function fixture design to meet different blank processing needs;
						</div>
					</li>
					<li>
						<div class="dot">·</div>
						<div class="ll">
							Equipped with 60000 rpm high-speed electric spindle, cooling and lubrication system;
						</div>
					</li>
					<li>
						<div class="dot">·</div>
						<div class="ll">Support multiple materials: zirconia and metal;</div>
					</li>
					<li>
						<div class="dot">·</div>
						<div class="ll">Adapt to tool magazine, automatic tool change, tool setting system;
						</div>
					</li>
					<li>
						<div class="dot">·</div>
						<div class="ll">
							Equipped with a unique optical scanning module to realize rapid positioning of blanks and model accuracy comparison;
						</div>
					</li>
					<li>
						<div class="dot">·</div>
						<div class="ll">automatically generate the processing program after  Input the model.</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>

    import solution_image_01 from '@/assets/resource/images/solution/image_solutions_precision_03.png'
    export default {
        data(){
            return {
                solution_image_01: solution_image_01
            };
        }
    }

</script>

<style scoped="">
	.ll {
		width: calc(100% - .625rem);
		margin-bottom: 1.375rem;
	}

	.dot {
		width: .625rem;
	}

	.dot, .ll {
		float: left;
		border: none;
		font-size: 1rem;
		color: #515555;
		letter-spacing: 0;
		text-align: justify;
		line-height: 1.5rem;
	}

	.list > ul > li {
		width: 100%;
	}

	.list > ul {
		width: 100%;
		height: 21rem;
		border: none;
	}

	.list > img {
		width: 100%;
		margin-bottom: 2.75rem;
	}

	.list {
		width: 54.5rem;
		border: none;
		margin-left: 7rem;
	}

	.dental-carving-machine-con {
		width: 61.5rem;
		height: 50.1875rem;
		border: none;
		margin-left: 0px;
	}

	.dental-carving-machine-list {
		width: 100%;
		height: 56.0625rem;
		border: none;
	}

	.x-tit-con {
		font-size: 1.5rem;
		color: #3B3A38;
		line-height: 3.25rem;
	}

	.title {
		width: calc(100% - 3.25rem);
		text-align: left;
		margin-left: 3.25rem;
		margin-top: 2.75rem;
		margin-bottom: 2.75rem;
	}

	.x-icon-keys {
		display: inline-block;
		content: url("../../../assets/resource/icons/ico_solutions.png");
		width: 2.75rem;
		height: 2.75rem;
		position: relative;
		top: .625rem;
		margin-right: 1rem;
	}
</style>


// WEBPACK FOOTER //
// src/components/zh-cn/solution/solution-dental-carving-machine.vue